import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

/**
 * Live per-user LARS authorization check. Calls the server (which reads the
 * user's "Enable LARS" flag) so a change takes effect immediately without a
 * re-login. Fails closed: any error resolves to "not authorized".
 */
@Injectable({ providedIn: 'root' })
export class LarsAccessService {
  constructor(private http: HttpClient) { }

  isEnabled$ = (): Observable<boolean> =>
    this.http.get<{ enabled: boolean }>('/api/AiAssistant/Access').pipe(
      map(r => !!r?.enabled),
      catchError(() => of(false)),
    );
}
